import { useQuery } from '@apollo/client';
import { useRouter } from '@application/utils';
import { graphql } from '@gql/gql';

export const BREED_GET_BREED = graphql(`
  query BreedGetBreed($take: Int, $where: DogBreedWhereInput) {
    findManyDogBreed(where: $where, take: $take) {
      ...BreedDetailsInfo
    }
  }
`);

export const useGetBreed = (id: string) => {
  const { language } = useRouter();

  const { data, error, loading } = useQuery(BREED_GET_BREED, {
    variables: {
      take: 1,
      where: {
        translations: { some: { AND: [{ url: { equals: id }, language: { equals: language } }] } },
        isSubBreed: { equals: false },
      },
    },
  });

  return {
    breed: data?.findManyDogBreed?.[0],
    breedError: error,
    breedLoading: loading,
  };
};
